// Image appends its own query string, so Elevate's ?timestamp= moves to modifiedDate.
export const getElevateImage = image => {
  const [src, query] = (image?.sources?.[0]?.url ?? '').split('?');
  return { src, modifiedDate: new URLSearchParams(query).get('timestamp') };
};
